/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Payment_Still_OwedInputs */

const vi_customer_debt_payment_still_owed = /** @type {(inputs: Customer_Debt_Payment_Still_OwedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`còn nợ`)
};

/**

* @param {Customer_Debt_Payment_Still_OwedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_payment_still_owed = /** @type {((inputs?: Customer_Debt_Payment_Still_OwedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Payment_Still_OwedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_payment_still_owed(inputs)
});